import { AfterViewInit, ChangeDetectionStrategy, Component, Host, Injector, Input, OnDestroy, OnInit } from '@angular/core';
import { Catalog } from '@df/catalog/catalog.interfaces';
import { UiComponent } from '@df/ui/ui.component';
import { AfterContentInitDirectiveService } from '@df/ui/common/after-content-init.directive';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { CategoryViewComponent } from '../category-view.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ProductListingComponent } from '../../../listing/product-listing.component';
import { CmsCategoryHeaderBlockComponent } from '../header/cms-category-header-block.component';

export namespace NCategoryViewLayout {
    export const BLOCK_ID = 'category-page-layout';
    export interface IBlockData extends Catalog.IBlockData<IContent> {}

    export interface IContent {
        /**
         * Top components list
         */
        topComponents: NICmsContentComponent.IData[];

        /**
         * Middle components list
         */
        middleComponents: NICmsContentComponent.IData[];

        /**
         * Bottom components list
         */
        bottomComponents: NICmsContentComponent.IData[];
    }
}
/**

/**
 * Component definition
 */
@Component({
    standalone: true,
    imports: [ICmsClientModule, ProductListingComponent, CmsCategoryHeaderBlockComponent],
    selector: 'category-view-layout',
    templateUrl: './category-view-layout.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<CategoryViewLayoutComponent>({
    id: NCategoryViewLayout.BLOCK_ID,
    block: {
        url: NCategoryViewLayout.BLOCK_ID
    },
    onDemandOnly: true,
    name: 'Category page layout',
    description: 'Category page layout block',
    fields: [
        <NICmsContentField.IComponentsField>{
            key: 'topComponents',
            type: NICmsContentField.EFieldType.components,
            title: 'Top components, above name',
            itemName: 'component',
            default: []
        },
        <NICmsContentField.IComponentsField>{
            key: 'middleComponents',
            type: NICmsContentField.EFieldType.components,
            title: 'Middle components, below name',
            itemName: 'component',
            default: []
        },
        <NICmsContentField.IComponentsField>{
            key: 'bottomComponents',
            type: NICmsContentField.EFieldType.components,
            title: 'Bottom components',
            itemName: 'component',
            default: []
        }
    ]
})
export class CategoryViewLayoutComponent extends UiComponent implements NICmsContentComponent.IComponent, OnInit, OnDestroy, AfterViewInit {
    @ICmsContent({
        type: 'blockContent'
    })
    content?: NCategoryViewLayout.IContent;

    @Input()
    variant?: string;

    protected override canDetach = false;

    /**
     * Category shorthand
     */
    get category() {
        return this.categoryView.model;
    }

    /**
     * Dependencies
     */
    constructor(
        private afterContentInit: AfterContentInitDirectiveService,
        @Host() public categoryView: CategoryViewComponent
    ) {
        super();
    }

    override ngOnInit() {
        this.afterContentInit.lock(this);
        super.ngOnInit();
    }

    ngAfterViewInit(): void {
        this.timeoutService.setTimeout(() => {
            this.afterContentInit.unlock(this);
        }, 1000);
    }

    /////////////////// HELPERS ////////////////////

    override detectChanges() {
        if (this.initiated) {
            this.client.isCms ? this.categoryView.detectChanges() : super.detectChanges();
        }
    }
}
